import React, { Component } from 'react';
import Search from "../../search/search";


class SlideSecondHome extends Component {
    render() {
        return (
            <div>
                <section className="slide_top">
                    <div className="container">
                        <div className="up_slider">
                            <div className="row spt1">
                                <form role="search"  acceptCharset="utf-8">
                                    <div className="col-md-7 advsearch">
                                        <h1>11059 Industry Reports and Counting …</h1>
                                        <div className="input-group pad-25">

                                        </div>
                                    </div>
                                </form>
                                <div className="col-md-5 hidden-sm hidden-xs">
                                    <a target="_blank" href="https://mordorintelligence.recruiterbox.com/"><img src="../../../img/hiring.jpg" data-src="../../img/hiring.jpg" className="img-responsive" alt="mordor" /></a>
                                    <h4
                                        className="home-hire"><a target="_blank" href="https://mordorintelligence.recruiterbox.com/">We are Hiring</a></h4>
                                </div>
                            </div>

                            <div className="row spt2 pad-t0">
                                <div className="col-md-4 paddy">
                                    <div className="spotlight_img">
                                        <img src="../../../img/spot_light1.png" data-src="../../../img/spot_light1.png" className="img-responsive" alt="mordor" />
                                    </div>
                                    <div className="spotlight_txt">
                                        <h3>Top notch support</h3>
                                        <h4>6 Month Post-Purchase Analyst Support</h4>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div className="col-md-4 paddy pad-0">
                                    <div className="spotlight_img">
                                        <img src="../../../img/spot_light2.png" data-src="../../../img/spot_light2.png" className="img-responsive" alt="mordor" />
                                    </div>
                                    <div className="spotlight_txt">
                                        <h3>Data in Excel </h3>
                                        <h4>Data from the Study Provided in Pivot Tables</h4>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div className="col-md-4 paddy">
                                    <div className="spotlight_img">
                                        <img src="../../../img/spot_light3.png" data-src="../../../img/spot_light3.png" className="img-responsive" alt="mordor" />
                                    </div>
                                    <div className="spotlight_txt">
                                        <h3>White label presentation</h3>
                                        <h4>Customized Snapshot on Request</h4>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}

export default SlideSecondHome;


// WEBPACK FOOTER //
// ./src/home/slide-second-home/slide-second-home.js